/*
 * This generates uniform collection cards. 
 * For use in search results, carousels, and eventually creator profiles
 * 
 */
let React = require("react");

export class CollectionCard extends React.Component {
    constructor(props) {
        super(props);
    }

    renderCollectionIcons(collection) {
        let icons = [],
            collectionIcons = collection.icons.slice(0, 6);

        collectionIcons.forEach(icon => {
            icons.push(
                <li
                    key={"collectionCard.collection.icon." + icon.id}
                    className="card-icon-item"
                >
                    <a
                        href={`${collection.permalink}?i=${icon.id}`}
                        className="card-icon-link"
                    >
                        <img src={icon.preview_url_84} alt={icon.term} />
                    </a>
                </li>
            );
        });

        // Pad out the icon list with dummies
        let iconDummies = 6 - icons.length;
        if (iconDummies > 0) {
            let i = 1;
            while (i <= iconDummies) {
                icons.push(
                    <li
                        key={"collectionCard.collection.icon.dummy." + i}
                        className="card-icon-item icon-dummy"
                    />
                );
                i++;
            }
        }
        return icons;
    }

    render() {
        let collection = this.props.collection,
            icons = this.renderCollectionIcons(collection);

        return (
            <div
                key={"collectionCard.collection." + collection.id}
                className="card-item padding-m"
            >
                <h1 className="font-medium weight-medium">
                    <a href={collection.permalink} className="card-link">
                        {collection.name}
                    </a>
                </h1>

                <ul className="card-icon-list">{icons}</ul>

                <div className="font-small margin-t-s">
                    <a href={collection.permalink} className="card-link">
                        {collection.icon_count} icons
                    </a>
                </div>
            </div>
        );
    }
}
